import { Monitor, Moon, Sun } from "lucide-react";
import { SegmentedControl, type Segment } from "~/components/segmented-control";
import { useTheme, type ThemePreference } from "~/lib/theme/context";

const OPTIONS: Segment<ThemePreference>[] = [
  { value: "system", label: "Automatic", icon: Monitor },
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
];

export function AppearanceCard() {
  const { preference, setPreference } = useTheme();
  return (
    <section className="border-hairline bg-card rounded-xl border p-5">
      <h2 className="type-headline">Appearance</h2>
      <p className="text-muted-foreground type-footnote mt-1">Automatic follows your phone or computer setting.</p>
      <SegmentedControl label="Appearance" value={preference} segments={OPTIONS} onChange={setPreference} className="mt-4" />
    </section>
  );
}
